export class ServerTime {
  constructor(readonly time: string) {}
}
